import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../Images/stackLogo2.svg';
import { AiOutlinePlus } from 'react-icons/ai';
import { LuMenu } from "react-icons/lu";
import PartnerContact from './ContactForm/PartnerContact';

const toggleMenu = (isMenuOpen, setIsMenuOpen) => {
    setIsMenuOpen(!isMenuOpen);
};

const scrollToSection = (sectionId, setIsMenuOpen) => {
    const element = document.getElementById(sectionId);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMenuOpen(false);
};

const handleContactClick = (navigate, setIsMenuOpen) => {
    navigate('/');
    setTimeout(() => {
        scrollToSection('contact', setIsMenuOpen);
    }, 100);
};

const isActiveLink = (location, path) => {
    return location.pathname.startsWith(path);
};

const handleOpenModal = (setIsModalOpen) => {
    setIsModalOpen(true);
};

const mobileHandleOpenModal = (setIsModalOpen, setIsMenuOpen) => {
    setIsModalOpen(true);
    setIsMenuOpen(false);
};

const handleCloseModal = (setIsModalOpen) => {
    setIsModalOpen(false);
};

// Header Component
function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <nav className="bg-white shadow-md fixed w-full z-20 top-0">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex items-center justify-between h-16">
                        <div className="flex items-center">
                            <Link to='/'>
                                <img src={logo} alt="Logo" className="h-10 w-auto mr-3" />
                            </Link>
                        </div>
                        {/* Desktop Navigation */}
                        <div className="hidden md:flex space-x-6">
                            <Link
                                to='/services'
                                className={`text-black ${isActiveLink(location, '/services') ? 'text-transparent bg-clip-text bg-gradient-to-r from-[#e00a7e] to-[#6c32ee]' : 'hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#e00a7e] hover:to-[#6c32ee]'} px-3 py-2 rounded-md text-base font-medium transition duration-300`}
                            >
                                Our Services
                            </Link>
                            <Link
                                to='/about'
                                className={`text-black ${isActiveLink(location, '/about') ? 'text-transparent bg-clip-text bg-gradient-to-r from-[#e00a7e] to-[#6c32ee]' : 'hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#e00a7e] hover:to-[#6c32ee]'} px-3 py-2 rounded-md text-base font-medium transition duration-300`}
                            >
                                About Us
                            </Link>
                            <Link
                                to='/work'
                                className={`text-black ${isActiveLink(location, '/work') ? 'text-transparent bg-clip-text bg-gradient-to-r from-[#e00a7e] to-[#6c32ee]' : 'hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#e00a7e] hover:to-[#6c32ee]'} px-3 py-2 rounded-md text-base font-medium transition duration-300`}
                            >
                                Our Work
                            </Link>
                            <Link
                                to='/contact'
                                className={`text-black ${isActiveLink(location, '/contact') ? 'text-transparent bg-clip-text bg-gradient-to-r from-[#e00a7e] to-[#6c32ee]' : 'hover:text-transparent hover:bg-clip-text hover:bg-gradient-to-r hover:from-[#e00a7e] hover:to-[#6c32ee]'} px-3 py-2 rounded-md text-base font-medium transition duration-300`}
                            >
                                Contact Us
                            </Link>
                            <button onClick={() => handleOpenModal(setIsModalOpen)} className="bg-gray-800 px-8 rounded-md text-sm font-medium transition duration-300 py-2 group">
                                <span className="text-white transition duration-300 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-[#e00a7e] group-hover:to-[#6c32ee]">
                                    Become Our Partner
                                </span>
                            </button>
                        </div>
                        {/* Mobile Menu Button */}
                        <div className="md:hidden">
                            <button
                                onClick={() => toggleMenu(isMenuOpen, setIsMenuOpen)}
                                className={`md:hidden p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-transform duration-800 ease-in-out ${isMenuOpen ? 'rotate-45' : ''}`}
                            >
                                {isMenuOpen ? <AiOutlinePlus size={24} className="text-gray-700" /> : <LuMenu size={24} className="text-gray-700" />}
                            </button>
                        </div>
                    </div>
                    {/* Mobile Menu Dropdown */}
                    {isMenuOpen && (
                        <div className=" h-screen space-y-6 px-6">
                            <nav className="flex flex-col items-center space-y-4 w-full">
                                <Link
                                    to='/services'
                                    onClick={() => toggleMenu(isMenuOpen, setIsMenuOpen)}
                                    className="text-gray-800 font-medium text-xl w-full text-center py-3"
                                >
                                    Our Services
                                </Link>
                                <Link
                                    to='/about'
                                    onClick={() => toggleMenu(isMenuOpen, setIsMenuOpen)}
                                    className="text-gray-800 font-medium text-xl w-full text-center py-3"
                                >
                                    About Us
                                </Link>
                                <Link
                                    to='/work'
                                    onClick={() => toggleMenu(isMenuOpen, setIsMenuOpen)}
                                    className="text-gray-800 font-medium text-xl w-full text-center py-3"
                                >
                                    Our Work
                                </Link>
                                <button
                                    onClick={() => handleContactClick(navigate, setIsMenuOpen)}
                                    className="text-gray-800 font-medium text-xl w-full text-center py-3"
                                >
                                    Contact Us
                                </button>
                            </nav>
                            <div className="flex justify-center space-y-4">
                                <button
                                    onClick={() => mobileHandleOpenModal(setIsModalOpen, setIsMenuOpen)}
                                    className=" bg-gray-900 text-white hover:bg-gray-800 px-6 py-3 rounded-lg text-base font-semibold transition-colors shadow-md"
                                >
                                    Become Our Partner
                                </button>
                            </div>
                        </div>
                    )}

                    <PartnerContact
                        isOpen={isModalOpen}
                        onClose={() => handleCloseModal(setIsModalOpen)}
                        className={`${isModalOpen ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-opacity duration-800 ease-in-out`}
                    />
                </div>
            </nav>
        </>
    );
}

export { toggleMenu, scrollToSection, handleContactClick, isActiveLink, handleOpenModal, mobileHandleOpenModal, handleCloseModal };

export default Header;
